<template>
	<div class="activityedit page-container">
		<div class="page-title">
			活动信息编辑
		</div>
		<div class="page-content custom-scroll-bar">
			<el-form :model="activity" :rules="rules" ref="activityForm" label-width="150px" class="ruleForm">
				<el-form-item label="活动名称" prop="name">
					<el-input v-model="activity.name" type="text" placeholder="请输入活动名称"></el-input>
				</el-form-item>
				<el-form-item label="活动描述" prop="description">
					<el-input type="textarea" v-model="activity.description" placeholder="请输入活动描述"></el-input>
				</el-form-item>
				<el-form-item label="是否对藏品分类限制" prop="typeFlag">
					<el-switch v-model="typeFlag" active-text="是" inactive-text="否">
					</el-switch>
				</el-form-item>
				<el-form-item label="藏品类别" prop="type" v-if="typeFlag" :rules=" [{ required: typeFlag,
					trigger: 'blur' , message: '请选择藏品类别' }]">
					<el-cascader v-model="activity.type" :props="props" :options="typeList" placeholder="请选择藏品类别"
						style="width: 400px;"></el-cascader>
				</el-form-item>
				<el-form-item label="是否对竞拍时间限制" prop="timeFlag">
					<el-switch v-model="timeFlag" active-text="是" inactive-text="否">
					</el-switch>
				</el-form-item>
				<el-form-item label="拍卖开始时间" v-if="timeFlag">
					<el-col :span="4">
						<el-form-item prop="date1" :rules=" [{ required: timeFlag,
					trigger: 'blur' , message: '请选择拍卖开始时间' }]">
							<el-date-picker type="date" placeholder="选择日期" v-model="activity.date1" format="yyyy-MM-dd"
								value-format="yyyy-MM-dd" :picker-options="pickerOptions">
							</el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="4">
						<el-form-item prop="date2" :rules=" [{ required: timeFlag,
					trigger: 'blur' , message: '请选择拍卖开始时间' }]">
							<el-time-picker placeholder="选择时间" v-model="activity.date2" value-format="HH:mm:ss">
							</el-time-picker>
						</el-form-item>
					</el-col>
				</el-form-item>
				<el-form-item label="拍卖结束时间" v-if="timeFlag">
					<el-col :span="4">
						<el-form-item prop="date3" :rules=" [{ required: timeFlag,
					trigger: 'blur' , message: '请选择拍卖结束时间' }]">
							<el-date-picker type="date" placeholder="选择日期" v-model="activity.date3" format="yyyy-MM-dd"
								value-format="yyyy-MM-dd" :picker-options="pickerOPtions2">
							</el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="4">
						<el-form-item prop="date4" :rules=" [{ required: timeFlag,
					trigger: 'blur' , message: '请选择拍卖结束时间' }]">
							<el-time-picker placeholder="选择时间" v-model="activity.date4" value-format="HH:mm:ss">
							</el-time-picker>
						</el-form-item>
					</el-col>
				</el-form-item>
				<el-form-item label="是否对起拍价限制" prop="startFlag">
					<el-switch v-model="startFlag" active-text="是" inactive-text="否">
					</el-switch>
				</el-form-item>
				<el-form-item label="起拍价" prop="start" v-if="startFlag" :rules=" [{ required: startFlag,
					trigger: 'blur' , message: '请输入起拍价' }]">
					<el-input v-model="activity.start" placeholder="请输入起拍价">
						<template slot="append">
							元
						</template>
					</el-input>
				</el-form-item>
				<el-form-item label="是否对加价幅度限制" prop="addFlag">
					<el-switch v-model="addFlag" active-text="是" inactive-text="否">
					</el-switch>
				</el-form-item>
				<el-form-item label="加价幅度" prop="add" v-if="addFlag" :rules=" [{ required: addFlag,
					trigger: 'blur' , message: '请输入加价幅度' }]">
					<el-input v-model="activity.add" placeholder="请输入加价幅度">
						<template slot="append">
							元
						</template>
					</el-input>
				</el-form-item>
				<el-form-item label="是否对保证金限制" prop="depositFlag">
					<el-switch v-model="depositFlag" active-text="是" inactive-text="否">
					</el-switch>
				</el-form-item>
				<el-form-item label="保证金" prop="deposit" v-if="depositFlag" :rules=" [{ required: depositFlag,
					trigger: 'blur' , message: '请输入保证金' }]">
					<el-input v-model="activity.deposit" placeholder="请输入保证金">
						<template slot="append">
							元
						</template>
					</el-input>
				</el-form-item>
				<div class="login-button">
					<el-button type="primary" :loading="loading" @click="saveCommodityInfo">保存活动信息</el-button>
				</div>
			</el-form>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'activityedit',
		data() {
			return {
				activity: {
					name: '',
					description: '',
					type: [],
					date1: '',
					date2: '',
					date3: '',
					date4: '',
					deposit: '',
					start: '',
					add: ''
				},
				typeFlag: false,
				timeFlag: false,
				startFlag: false,
				addFlag: false,
				depositFlag: false,
				rules: {
					name: [{
						required: true,
						trigger: 'blur',
						message: '请输入藏品名称'
					}],
					description: [{
						required: true,
						trigger: 'blur',
						message: '请输入活动描述'
					}]
				},
				id: '',
				loading: false,
				typeList: [],
				props: {
					children: 'childrens',
					label: 'typeName',
					value: 'lotTypeId'
				},
				pickerOptions: {
					disabledDate: time => {
						if (this.activity.date3) {
							return (
								time.getTime() < Date.now() - 8.64e7 ||
								time.getTime() > Date.parse(this.activity.date3) /*开始日期要在选择的结束日期之前*/
							);
						}
						return time.getTime() < Date.now() - 8.64e7; /*今天及以后*/
						// return time.getTime() > Date.now() - 8.64e6; /*今天及之前，注意数字不一样*/
					}
				},
				pickerOPtions2: {
					disabledDate: time => {
						if (this.activity.date1) {
							return (
								time.getTime() < Date.now() - 8.64e6 ||
								time.getTime() < Date.parse(this.activity.date1) /*结束日期要在选择的开始日期之后*/
							);
						}
						return time.getTime() < Date.now() - 8.64e7; /*今天及以后*/
						// return time.getTime() > Date.now() - 8.64e6; /*今天及之前*/
					}
				}
			};
		},
		methods: {
			fetchData() {
				this.$api.activityDetail({
					id: this.id
				}, res => {
					if (res.code == 200) {
						this.activity = {
							name: res.data.activityName,
							description: res.data.activityDescribe,
							type: res.data.lotTypeId.split(','),
							date1: res.data.startTime.split(' ')[0],
							date2: res.data.startTime.split(' ')[1],
							date3: res.data.endTime.split(' ')[0],
							date4: res.data.endTime.split(' ')[1],
							start: res.data.startPrice,
							add: res.data.priceIncreaseRange,
							deposit: res.data.bond
						}
						this.typeFlag = res.data.isTypeLimit == 1 ? true : false
						this.timeFlag = res.data.isAuctionTime == 1 ? true : false
						this.startFlag = res.data.isStartPrice == 1 ? true : false
						this.addFlag = res.data.isRange == 1 ? true : false
						this.depositFlag = res.data.isBond == 1 ? true : false
					}
				})
			},
			saveCommodityInfo() {
				this.$refs.activityForm.validate(valid => {
					if (valid) {
						this.$api.activityEdit({
							activityName: this.activity.name,
							activityDescribe: this.activity.description,
							isTypeLimit: this.typeFlag ? 1 : 0,
							lotTypeId: this.activity.type.join(','),
							isAuctionTime: this.timeFlag ? 1 : 0,
							startTime: this.activity.date1 + ' ' + this.activity.date2,
							endTime: this.activity.date3 + ' ' + this.activity.date4,
							isStartPrice: this.startFlag ? 1 : 0,
							startPrice: this.activity.start,
							isRange: this.addFlag ? 1 : 0,
							priceIncreaseRange: this.activity.add,
							isBond: this.depositFlag ? 1 : 0,
							bond: this.activity.deposit,
							id: this.id
						}, res => {
							if (res.code == 200) {
								this.$message({
									message: (this.id == '' ? '新增' : '编辑') + '活动成功！',
									duration: 2000,
									type: 'success',
									onClose: () => {
										this.$router.back()
									}
								})
							}
						})
					}
				})
			},
			fetchClassify() {
				this.$api.classifyAll({}, res => {
					if (res.code == 200) {
						this.typeList = res.data
					}
				})
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
			this.id = this.$route.query.id
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
			if (this.id != '') {
				this.fetchData()
			}
			this.fetchClassify()
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	};
</script>

<style lang="less" scoped="scoped">
	.activityedit {
		overflow: hidden;
	}

	.page-title {
		width: 100%;
		height: 50px;
		display: flex;
		align-items: center;
		padding: 0px @vue-spacing-row-sm;
		box-sizing: border-box;
		background: @vue-bg-color-grey;
	}

	.page-content {
		width: 100%;
		height: calc(100% - 50px);
		padding: @vue-spacing-col-base @vue-spacing-row-base;
		box-sizing: border-box;
		overflow: auto;
	}

	.upload-video,
	.upload-image,
	.upload-datum,
	.rich-text {
		display: flex;
		margin-bottom: @vue-spacing-col-lg;
	}

	.upload-key,
	.key {
		width: 150px;
		height: 50px;
		display: flex;
		align-items: center;
		justify-content: flex-end;
		padding-right: @vue-spacing-row-sm + 4;
		box-sizing: border-box;
		font-size: @vue-font-size-sm - 2;
		color: @vue-text-color;

		span {
			color: @vue-text-color-red;
		}
	}

	.upload-value,
	.value {
		width: calc(100% - 450px);
	}

	.el-input,
	.el-select,
	.el-textarea {
		width: 400px;
	}

	.el-date-editor {
		width: 200px;
	}

	.avatar-uploader .el-upload {
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 148px;
		height: 148px;
		line-height: 148px;
		text-align: center;
		border: 1px dashed #d9d9d9;
		box-sizing: border-box;
		border-radius: @vue-border-radius-base;
		background: #fbfdff;
	}

	.avatar-uploader-icon:hover {
		border-color: #409EFF;
	}

	.video {
		width: 148px;
		height: 148px;
		display: block;
	}

	.login-button {
		padding-left: 150px;
		box-sizing: border-box;
		margin-bottom: @vue-spacing-col-lg*2;

		.el-button {
			width: 200px;
		}
	}
</style>
